export const MANAGER_TOKEN_KEY = "ttt_auth_token";
export const MANAGER_SESSION_EXPIRED_EVENT = "ttt:manager-session-expired";

const RETURN_TO_KEY = "ttt_auth_return_to";
const NOTICE_KEY = "ttt_auth_notice";

/* The Team -> Ops handoff lived here: an `sso=1` marker plus an HttpOnly
 * parent-domain cookie redeemed at /api/ts/manage-session/claim. It existed
 * only because Ops sat on a separate origin from the hub and localStorage does
 * not cross origins, so the token could travel neither in storage nor in the
 * URL. Ops is at /ops on the hub's own origin now: the tile stores the token
 * directly and there is nothing left to claim. */

function currentManagerLocation() {
  if (typeof window === "undefined") return null;
  const { pathname, search, hash } = window.location;
  if (!pathname || pathname === "/login") return null;
  return `${pathname}${search || ""}${hash || ""}`;
}

export function expireManagerSession() {
  if (typeof window === "undefined") return;

  const returnTo = currentManagerLocation();
  if (returnTo) sessionStorage.setItem(RETURN_TO_KEY, returnTo);
  sessionStorage.setItem(NOTICE_KEY, "Your session expired. Please sign in again.");
  localStorage.removeItem(MANAGER_TOKEN_KEY);
  window.dispatchEvent(new Event(MANAGER_SESSION_EXPIRED_EVENT));
}

export function consumeManagerSessionNotice() {
  if (typeof window === "undefined") return "";
  const notice = sessionStorage.getItem(NOTICE_KEY) || "";
  sessionStorage.removeItem(NOTICE_KEY);
  return notice;
}

export function consumeManagerReturnTo() {
  if (typeof window === "undefined") return "/";
  const returnTo = sessionStorage.getItem(RETURN_TO_KEY) || "/";
  sessionStorage.removeItem(RETURN_TO_KEY);
  return returnTo.startsWith("/") && !returnTo.startsWith("//") && returnTo !== "/login"
    ? returnTo
    : "/";
}
